const E_GenericAction = {
	FETCH_PENDING: "FETCH_PENDING",
	FETCH_FULFILLED: "FETCH_FULFILLED",
	FETCH_REJECTED: "FETCH_REJECTED",
	FETCH_ABORTED: "FETCH_ABORTED",
	BACKGROUND_FETCH_PENDING: "BACKGROUND_FETCH_PENDING",
	BACKGROUND_FETCH_REJECTED: "BACKGROUND_FETCH_REJECTED",

	EDIT_INIT: "EDIT_INIT",
	EDIT_SET: "EDIT_SET",
	EDIT_CANCEL: "EDIT_CANCEL",
	EDIT_MODIFY: "EDIT_MODIFY",
	EDIT_PENDING: "EDIT_PENDING",
	EDIT_FULFILLED: "EDIT_FULFILLED",
	EDIT_REJECTED: "EDIT_REJECTED",

	ITEM_CLEAR: "ITEM_CLEAR",
	LIST_CLEAR: "LIST_CLEAR",
	ITEM_DELETE: "ITEM_DELETE",
	CACHE_CLEAR: "CACHE_CLEAR",
};

const Action_Generic_Type = (type) => {
	return {
		type
	}
};

const Action_Generic_Payload = (type, payload) => {
	return {
		type,
		payload
	}
};

const Action_Generic_Modification = (type, value, path, modificationType) => ({
	type,
	modification: {
		value,
		path,
		type: modificationType,
	},
});

export class GenericActions {
	static get enum() {
		return {
			actionType: E_GenericAction,
		};
	}

	static get action() {
		return {
			type: Action_Generic_Type,
			payload: Action_Generic_Payload,
			modification: Action_Generic_Modification,
		}
	}

	static getTypeAction(type) {
		return Action_Generic_Type(type);
	}

	static getPayloadAction(type, payload) {
		return Action_Generic_Payload(type, payload);
	}

	static getModificationAction(type, value, path, modificationType) {
		return Action_Generic_Modification(type, value, path, modificationType);
	}
}
